module.exports = __webpack_public_path__ + "static/media/SCDream4.14cc8f9e.otf";